import Home from "../views/Home";
import Contact from "../views/Contact";
import About from "../views/About";
import Faq from "../views/Faq";
import Toontips from "../views/Toontips";
import Invasions from "../views/Invasions";
import Bossbot from "../views/cogs/Bossbot";
import Cashbot from "../views/cogs/Cashbot";
import Sellbot from "../views/cogs/sellbot/Sellbot";
import Lawbot from "../views/cogs/Lawbot";
import Gardening from "../views/activities/Gardening";
import Fishing from "../views/activities/Fishing";
import Golfing from "../views/activities/Golfing";
import Racing from "../views/activities/Racing";
import Doodles from "../views/activities/Doodles";
import Activities from "../views/Activities";
import Cogs from "../views/Cogs";
import Neighborhoods from "../views/Neighborhoods";
import PrivacyPolicy from "../views/PrivacyPolicy";
import FieldOffices from "../views/cogs/sellbot/FieldOffices";
import TaskForce from "../views/cogs/sellbot/TaskForce";
import WhatsNew from "../views/WhatsNew";
import Gags from "../views/Gags";
import UnderNewManagement from "../views/cogs/UnderNewManagement";
import StatusEffects from "../views/StatusEffects";

export const contentRoutes = [
    { path: "/", Component: Home },
    { path: "/invasions", Component: Invasions },
    { path: "/whatsnew", Component: WhatsNew },
    { path: "/about", Component: About },
    { path: "/contact", Component: Contact },
    { path: "/faq", Component: Faq },
    { path: "/toontips", Component: Toontips },
    { path: "/bossbots", Component: Bossbot },
    { path: "/cashbots", Component: Cashbot },
    { path: "/sellbots", Component: Sellbot },
    { path: "/lawbots", Component: Lawbot },
    { path: "/gardening", Component: Gardening },
    { path: "/fishing", Component: Fishing },
    { path: "/golfing", Component: Golfing },
    { path: "/racing", Component: Racing },
    { path: "/doodles", Component: Doodles },
    { path: "/activities", Component: Activities },
    { path: "/cogs", Component: Cogs },
    { path: "/neighborhoods", Component: Neighborhoods },
    { path: "/privacypolicy", Component: PrivacyPolicy },
    { path: "/fieldoffices", Component: FieldOffices },
    { path: "/taskforce", Component: TaskForce },
    { path: "/gags", Component: Gags },
    { path: "/undernewmanagement", Component: UnderNewManagement },
    { path: "/statuseffects", Component: StatusEffects },
];
